// ==============================|| CHAT - DADOS MOCK ||============================== //
// Dados temporários apenas para avaliação visual do componente pela equipe.
// Quando o backend existir, substituir este arquivo por chamadas a src/api/chat.js
// (membros do tenant + histórico de conversas + envio de mensagem).

// Membros da equipe com acesso ao mesmo tenant.
// status: 'online' | 'ausente' | 'offline'
export const membrosEquipe = [
  { id: 1, nome: 'Ana Beatriz Ramos', area: 'Auditoria Interna', status: 'online' },
  { id: 2, nome: 'Carlos Eduardo Lima', area: 'Compliance', status: 'online' },
  { id: 3, nome: 'Fernanda Kuster', area: 'Gestão de Riscos', status: 'ausente' },
  { id: 4, nome: 'Juliana Alves', area: 'Jurídico', status: 'online' },
  { id: 5, nome: 'Marcos Antônio Prado', area: 'Controles Internos', status: 'offline' },
  { id: 6, nome: 'Patrícia Nogueira', area: 'Controladoria', status: 'online' },
  { id: 7, nome: 'Rafael Menezes', area: 'Segurança da Informação', status: 'offline' }
];

// Conversas. remetente: 'eu' | 'contato'
// situacao (apenas para 'eu'): 'enviada' | 'entregue' | 'lida'
export const conversas = [
  {
    id: 1,
    idMembro: 1,
    naoLidas: 2,
    mensagens: [
      { id: 1, remetente: 'contato', texto: 'Eduardo, bom dia! Consegue olhar o teste do controle CTR-114 hoje?', hora: '08:42', dia: 'Ontem' },
      { id: 2, remetente: 'eu', texto: 'Bom dia, Ana. Consigo sim, depois das 14h.', hora: '08:55', dia: 'Ontem', situacao: 'lida' },
      { id: 3, remetente: 'contato', texto: 'Perfeito. Já anexei as evidências do ciclo 2026.1 na pasta do processo.', hora: '09:03', dia: 'Ontem' },
      { id: 4, remetente: 'eu', texto: 'Vi aqui. Faltou o print da conciliação, dá uma olhada?', hora: '14:20', dia: 'Ontem', situacao: 'lida' },
      { id: 5, remetente: 'contato', texto: 'Verdade, subi agora. 👍', hora: '09:12', dia: 'Hoje' },
      { id: 6, remetente: 'contato', texto: 'Aproveitando: o plano de ação PA-278 vence sexta.', hora: '09:13', dia: 'Hoje' }
    ]
  },
  {
    id: 2,
    idMembro: 2,
    naoLidas: 1,
    mensagens: [
      { id: 1, remetente: 'eu', texto: 'Carlos, a matriz de riscos da Unidade Sul já foi aprovada?', hora: '16:31', dia: 'Ontem', situacao: 'lida' },
      { id: 2, remetente: 'contato', texto: 'Aprovada pelo comitê na quarta. Vou publicar a versão 3 amanhã.', hora: '16:48', dia: 'Ontem' },
      { id: 3, remetente: 'contato', texto: 'Te marquei como revisor no fluxo de autorização.', hora: '08:05', dia: 'Hoje' }
    ]
  },
  {
    id: 3,
    idMembro: 6,
    naoLidas: 0,
    mensagens: [
      { id: 1, remetente: 'contato', texto: 'O relatório de deficiências saiu com 12 apontamentos abertos.', hora: '11:02', dia: 'Hoje' },
      { id: 2, remetente: 'eu', texto: 'Obrigado, Patrícia. Vou distribuir os responsáveis ainda hoje.', hora: '11:15', dia: 'Hoje', situacao: 'entregue' }
    ]
  },
  {
    id: 4,
    idMembro: 3,
    naoLidas: 0,
    mensagens: [
      { id: 1, remetente: 'contato', texto: 'Subi a nova versão do questionário de avaliação.', hora: '17:20', dia: 'Ontem' },
      { id: 2, remetente: 'eu', texto: 'Valeu! Reviso na segunda.', hora: '17:34', dia: 'Ontem', situacao: 'lida' }
    ]
  },
  {
    id: 5,
    idMembro: 4,
    naoLidas: 0,
    mensagens: [
      { id: 1, remetente: 'eu', texto: 'Juliana, precisamos do parecer do processo 0021-45 para fechar o andamento.', hora: '10:48', dia: 'Hoje', situacao: 'enviada' }
    ]
  },
  {
    id: 6,
    idMembro: 5,
    naoLidas: 0,
    mensagens: [
      { id: 1, remetente: 'contato', texto: 'Fechei o teste de desenho dos controles de acesso.', hora: '15:10', dia: '02/09' },
      { id: 2, remetente: 'eu', texto: 'Show. Já pode marcar como concluído.', hora: '15:22', dia: '02/09', situacao: 'lida' }
    ]
  },
  {
    id: 7,
    idMembro: 7,
    naoLidas: 0,
    mensagens: [
      { id: 1, remetente: 'contato', texto: 'A integração do SSO entra em homologação semana que vem.', hora: '09:30', dia: '01/09' }
    ]
  }
];

// Respostas automáticas apenas para simular a conversa durante a demonstração.
export const respostasSimuladas = [
  'Certo, já estou olhando por aqui.',
  'Combinado! Te aviso quando terminar.',
  'Consigo sim, me dá uns minutos.',
  'Boa, isso resolve o apontamento.',
  'Vou anexar a evidência no processo.',
  'Perfeito, obrigada! 👍'
];

// Iniciais para o avatar (mesmo padrão usado no header do sistema).
export const obterIniciais = (nome = '') => {
  const partes = nome.trim().split(/\s+/).filter((p) => p.length > 2);
  const base = partes.length > 1 ? partes : nome.trim().split(/\s+/);
  return `${base[0]?.[0] ?? ''}${base.length > 1 ? base[base.length - 1][0] : ''}`.toUpperCase();
};

// Cor estável por membro, derivada da paleta do tema ativo (respeita o preset de cores).
export const corDoAvatar = (theme, id) => {
  const paletas = [
    theme.palette.primary,
    theme.palette.success,
    theme.palette.warning,
    theme.palette.info ?? theme.palette.primary,
    theme.palette.error,
    theme.palette.secondary
  ];
  return paletas[id % paletas.length];
};
